namespace TabAurous.OMS {
    export interface CurrencyMasterRow {
        CurrencyId?: number;
        CurrencySymbol?: string;
        CurrencyName?: string;
        SubunitName?: string;
        NoOfDecimalPlaces?: number;
        Narration?: string;
        IsDefault?: boolean;
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
    }

    export namespace CurrencyMasterRow {
        export const idProperty = 'CurrencyId';
        export const nameProperty = 'CurrencySymbol';
        export const localTextPrefix = 'OMS.CurrencyMaster';
        export const lookupKey = 'OMS.CurrencyMaster';

        export function getLookup(): Q.Lookup<CurrencyMasterRow> {
            return Q.getLookup<CurrencyMasterRow>('OMS.CurrencyMaster');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CurrencyId = "CurrencyId",
            CurrencySymbol = "CurrencySymbol",
            CurrencyName = "CurrencyName",
            SubunitName = "SubunitName",
            NoOfDecimalPlaces = "NoOfDecimalPlaces",
            Narration = "Narration",
            IsDefault = "IsDefault",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2"
        }
    }
}
